module.exports = __webpack_public_path__ + "img/airplay.76e11edb.svg";